<template>
  <div class="layout">
    <slot name="header" />
    <main class="layout__content">
      <slot name="content" />
    </main>
    <div class="layout__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import keyboardMode from '~~/common/vue/mixins/keyboard-mode';

export default {
  name: 'EStickyFooterLayout',
  mixins: [keyboardMode],
};
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: $gray-10;
  overflow-x: hidden;

  @include desktop {
    background-color: $white;
  }
}

.layout__content {
  flex: 1;
}
</style>
